import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

import ActionButton from './ActionButton';

const minHeight = '80px';
const slideIn = keyframes`
  from {
    transform: translateY(${minHeight});
    opacity: 0;
  }

  to {
    transform: translateY(0px);
    opacity: 1;
  }
`;
const slideOut = keyframes`
  from {
    transform: translateY(0px);
    opacity: 1;
  }

  to {
    transform: translateY(${minHeight});
    opacity: 0;
  }
`;
const BottomSheet = styled.div`
  position: ${({ visible }) => (visible ? 'fixed' : 'none')};
  bottom: ${({ bottom }) => `${bottom}px`};
  left: 0;
  right: 0;
  
  display: flex;

  min-height: ${minHeight};

  background-color: white;
  box-shadow: 0 0 12px ${({ theme: { palette } }) => palette.border};

  animation: ${({ visible }) => (visible ? slideIn : slideOut)} 0.4s;
`;

BottomSheet.ActionButton = ActionButton;

BottomSheet.propTypes = {
  bottom: PropTypes.number.isRequired,
  visible: PropTypes.bool.isRequired,
};

export default BottomSheet;
